var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line no-restricted-imports
import ReactTransition from 'react-transition-group/Transition';
import { window } from './browser';
var MockedTransition = /** @class */ (function (_super) {
    __extends(MockedTransition, _super);
    function MockedTransition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MockedTransition.prototype.componentDidMount = function () {
        if (this.props.appear && this.props.in) {
            this._enter({ isAppearing: true });
        }
    };
    MockedTransition.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.in !== this.props.in) {
            if (this.props.in) {
                this._enter();
            }
            else {
                this._exit();
            }
        }
    };
    Object.defineProperty(MockedTransition.prototype, "_node", {
        get: function () {
            // eslint-disable-next-line react/no-find-dom-node
            return ReactDOM.findDOMNode(this);
        },
        enumerable: false,
        configurable: true
    });
    MockedTransition.prototype._enter = function (_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.isAppearing, isAppearing = _c === void 0 ? false : _c;
        if (this.props.onEnter) {
            this.props.onEnter(this._node, isAppearing);
        }
        if (this.props.onEntering) {
            this.props.onEntering(this._node, isAppearing);
        }
        if (this.props.onEntered) {
            this.props.onEntered(this._node, isAppearing);
        }
    };
    MockedTransition.prototype._exit = function () {
        if (this.props.onExit) {
            this.props.onExit(this._node);
        }
        if (this.props.onExiting) {
            this.props.onExiting(this._node);
        }
        if (this.props.onExited) {
            this.props.onExited(this._node);
        }
    };
    MockedTransition.prototype.render = function () {
        var _a = this.props, show = _a.in, children = _a.children;
        if (!show) {
            return null;
        }
        if (typeof children === 'function') {
            return children(show ? 'entered' : 'exited');
        }
        return children;
    };
    return MockedTransition;
}(React.PureComponent));
export { MockedTransition };
export var Transition = window && window.IS_HAPPO ? MockedTransition : ReactTransition;
